/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/barcode/BarcodeTextLocalization.yaml
/**
Configuration of the all strings for barcode scanner.
*/
export class BarcodeTextLocalization {
    /** @param source {@displayType `DeepPartial<BarcodeTextLocalization>`} */
    constructor(source = {}) {
        /**
          Cancel button text for the top bar.
          
          Default is "Cancel"
          */
        this.topBarCancelButton = 'Cancel';
        /**
          Title for the top bar.
          
          Default is "Scan Item"
          */
        this.topBarTitle = 'Scan Item';
        /**
          User guidance text.
          
          Default is "Move the finder over a barcode"
          */
        this.userGuidance = 'Move the finder over a barcode';
        /**
          Loading message for barcode info mapping.
          
          Default is "Loading details..."
          */
        this.barcodeInfoMappingLoadingMessage = 'Loading details...';
        /**
          Title for the barcode info mapping error state.
          
          Default is "Connection Error!"
          */
        this.barcodeInfoMappingErrorStateTitle = 'Connection Error!';
        /**
          Subtitle for the barcode info mapping error state.
          
          Default is "There was an issue and the data requested was not fetched. You could try again or discard this result to start a new scan."
          */
        this.barcodeInfoMappingErrorStateSubtitle = 'There was an issue and the data requested was not fetched. You could try again or discard this result to start a new scan.';
        /**
          Retry button text for the barcode info mapping error state.
          
          Default is "Retry"
          */
        this.barcodeInfoMappingErrorStateRetryButton = 'Retry';
        /**
          Cancel button text for the barcode info mapping error state.
          
          Default is "Cancel"
          */
        this.barcodeInfoMappingErrorStateCancelButton = 'Cancel';
        /**
          Title for the manual count edit dialog.
          
          Default is "Update count"
          */
        this.manualCountEditDialogTitle = 'Update count';
        /**
          Info for the manual count edit dialog.
          
          Default is "Adjust the number of items you scanned."
          */
        this.manualCountEditDialogInfo = 'Adjust the number of items you scanned.';
        /**
          Update button text for the manual count edit dialog.
          
          Default is "Update"
          */
        this.manualCountEditDialogUpdateButton = 'Update';
        /**
          Cancel button text for the manual count edit dialog.
          
          Default is "Cancel"
          */
        this.manualCountEditDialogCancelButton = 'Cancel';
        /**
          Reset button text for the barcode sheet.
          
          Default is "Reset"
          */
        this.sheetResetButton = 'Reset';
        /**
          Clear all button text for the barcode sheet.
          
          Default is "Clear all"
          */
        this.sheetClearAllButton = 'Clear all';
        /**
          Submit button text for the barcode sheet.
          
          Default is "Submit"
          */
        this.sheetSubmitButton = 'Submit';
        /**
          Start scanning button text for the barcode sheet.
          
          Default is "Start scanning"
          */
        this.sheetStartScanningButton = 'Start scanning';
        /**
          Title for the barcode sheet placeholder.
          
          Default is "No barcodes here!"
          */
        this.sheetPlaceholderTitle = 'No barcodes here!';
        /**
          Subtitle for the barcode sheet placeholder.
          
          Default is "The barcode list is currently empty. Close this sheet and scan your items to add them."
          */
        this.sheetPlaceholderSubtitle = 'The barcode list is currently empty. Close this sheet and scan your items to add them.';
        /**
          Cancel button text for the single mode confirmation dialog.
          
          Default is "Close"
          */
        this.singleModeConfirmationCancelButton = 'Close';
        /**
          Title for the multiple mode barcode sheet.
          
          Default is "%d items"
          */
        this.multipleModeSheetTitle = '%d items';
        /**
          Title for the find and pick barcode sheet.
          
          Default is "%d/%d scanned"
          */
        this.findAndPickSheetTitle = '%d/%d scanned';
        /**
          Subtitle for the find and pick barcode sheet.
          
          Default is "%d/%d added"
          */
        this.findAndPickSheetBarcodeItemSubtitle = '%d/%d added';
        /**
          Title for the find and pick partial alert.
          
          Default is "Incomplete scan!"
          */
        this.findAndPickPartialAlertTitle = 'Incomplete scan!';
        /**
          Subtitle for the find and pick partial alert.
          
          Default is "Some codes are yet to be scanned. Proceed with submission anyway?"
          */
        this.findAndPickPartialAlertSubtitle = 'Some codes are yet to be scanned. Proceed with submission anyway?';
        /**
          Cancel button text for the find and pick partial alert.
          
          Default is "Cancel"
          */
        this.findAndPickPartialAlertCancelButton = 'Cancel';
        /**
          Submit button text for the find and pick partial alert.
          
          Default is "Yes, Submit"
          */
        this.findAndPickPartialAlertSubmitButton = 'Yes, Submit';
        /**
          Title for the find and pick complete alert.
          
          Default is "All codes found!"
          */
        this.findAndPickCompleteAlertTitle = 'All codes found!';
        /**
          Subtitle for the find and pick complete alert.
          
          Default is "You have successfully scanned all codes. Proceed with submission?"
          */
        this.findAndPickCompleteAlertSubtitle = 'You have successfully scanned all codes. Proceed with submission?';
        /**
          Cancel button text for the find and pick complete alert.
          
          Default is "Dismiss"
          */
        this.findAndPickCompleteAlertCancelButton = 'Dismiss';
        /**
          Submit button text for the find and pick complete alert.
          
          Default is "Submit"
          */
        this.findAndPickCompleteAlertSubmitButton = 'Submit';
        /**
          Accessibility description for the 'cancel' button in the top bar.
          
          Default is "Cancel"
          */
        this.accessibilityDescriptionCancelButton = 'Cancel';
        /**
          Accessibility description for the flash button.
          
          Default is "Toggle flash"
          */
        this.accessibilityDescriptionFlashButton = 'Toggle flash';
        /**
          Accessibility description for the zoom button.
          
          Default is "Toggle camera zoom"
          */
        this.accessibilityDescriptionZoomButton = 'Toggle camera zoom';
        /**
          Accessibility description for the flip camera button.
          
          Default is "Flip camera"
          */
        this.accessibilityDescriptionFlipCameraButton = 'Flip camera';
        /**
          The title of the camera permission dialog.
          
          Default is "Camera permission denied!"
          */
        this.cameraPermissionEnableCameraTitle = 'Camera permission denied!';
        /**
          The explanation text of the camera permission dialog.
          
          Default is "Please allow the usage of the camera to start the scanning process."
          */
        this.cameraPermissionEnableCameraExplanation = 'Please allow the usage of the camera to start the scanning process.';
        /**
          The 'enable' button title of the camera permission dialog.
          
          Default is "Grant permission"
          */
        this.cameraPermissionEnableCameraButton = 'Grant permission';
        /**
          The 'close' button title of the camera permission dialog.
          
          Default is "Close"
          */
        this.cameraPermissionCloseButton = 'Close';
        /**
          The accessibility hint for the 'enable' button of the camera permission dialog.
          
          Default is "Tap to grant camera permission"
          */
        this.accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
        /**
          The accessibility hint for the 'close' button of the camera permission dialog.
          
          Default is "Close screen without granting permission"
          */
        this.accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';
        if (source.topBarCancelButton !== undefined) {
            this.topBarCancelButton = source.topBarCancelButton;
        }
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = source.topBarTitle;
        }
        if (source.userGuidance !== undefined) {
            this.userGuidance = source.userGuidance;
        }
        if (source.barcodeInfoMappingLoadingMessage !== undefined) {
            this.barcodeInfoMappingLoadingMessage = source.barcodeInfoMappingLoadingMessage;
        }
        if (source.barcodeInfoMappingErrorStateTitle !== undefined) {
            this.barcodeInfoMappingErrorStateTitle = source.barcodeInfoMappingErrorStateTitle;
        }
        if (source.barcodeInfoMappingErrorStateSubtitle !== undefined) {
            this.barcodeInfoMappingErrorStateSubtitle = source.barcodeInfoMappingErrorStateSubtitle;
        }
        if (source.barcodeInfoMappingErrorStateRetryButton !== undefined) {
            this.barcodeInfoMappingErrorStateRetryButton = source.barcodeInfoMappingErrorStateRetryButton;
        }
        if (source.barcodeInfoMappingErrorStateCancelButton !== undefined) {
            this.barcodeInfoMappingErrorStateCancelButton = source.barcodeInfoMappingErrorStateCancelButton;
        }
        if (source.manualCountEditDialogTitle !== undefined) {
            this.manualCountEditDialogTitle = source.manualCountEditDialogTitle;
        }
        if (source.manualCountEditDialogInfo !== undefined) {
            this.manualCountEditDialogInfo = source.manualCountEditDialogInfo;
        }
        if (source.manualCountEditDialogUpdateButton !== undefined) {
            this.manualCountEditDialogUpdateButton = source.manualCountEditDialogUpdateButton;
        }
        if (source.manualCountEditDialogCancelButton !== undefined) {
            this.manualCountEditDialogCancelButton = source.manualCountEditDialogCancelButton;
        }
        if (source.sheetResetButton !== undefined) {
            this.sheetResetButton = source.sheetResetButton;
        }
        if (source.sheetClearAllButton !== undefined) {
            this.sheetClearAllButton = source.sheetClearAllButton;
        }
        if (source.sheetSubmitButton !== undefined) {
            this.sheetSubmitButton = source.sheetSubmitButton;
        }
        if (source.sheetStartScanningButton !== undefined) {
            this.sheetStartScanningButton = source.sheetStartScanningButton;
        }
        if (source.sheetPlaceholderTitle !== undefined) {
            this.sheetPlaceholderTitle = source.sheetPlaceholderTitle;
        }
        if (source.sheetPlaceholderSubtitle !== undefined) {
            this.sheetPlaceholderSubtitle = source.sheetPlaceholderSubtitle;
        }
        if (source.singleModeConfirmationCancelButton !== undefined) {
            this.singleModeConfirmationCancelButton = source.singleModeConfirmationCancelButton;
        }
        if (source.multipleModeSheetTitle !== undefined) {
            this.multipleModeSheetTitle = source.multipleModeSheetTitle;
        }
        if (source.findAndPickSheetTitle !== undefined) {
            this.findAndPickSheetTitle = source.findAndPickSheetTitle;
        }
        if (source.findAndPickSheetBarcodeItemSubtitle !== undefined) {
            this.findAndPickSheetBarcodeItemSubtitle = source.findAndPickSheetBarcodeItemSubtitle;
        }
        if (source.findAndPickPartialAlertTitle !== undefined) {
            this.findAndPickPartialAlertTitle = source.findAndPickPartialAlertTitle;
        }
        if (source.findAndPickPartialAlertSubtitle !== undefined) {
            this.findAndPickPartialAlertSubtitle = source.findAndPickPartialAlertSubtitle;
        }
        if (source.findAndPickPartialAlertCancelButton !== undefined) {
            this.findAndPickPartialAlertCancelButton = source.findAndPickPartialAlertCancelButton;
        }
        if (source.findAndPickPartialAlertSubmitButton !== undefined) {
            this.findAndPickPartialAlertSubmitButton = source.findAndPickPartialAlertSubmitButton;
        }
        if (source.findAndPickCompleteAlertTitle !== undefined) {
            this.findAndPickCompleteAlertTitle = source.findAndPickCompleteAlertTitle;
        }
        if (source.findAndPickCompleteAlertSubtitle !== undefined) {
            this.findAndPickCompleteAlertSubtitle = source.findAndPickCompleteAlertSubtitle;
        }
        if (source.findAndPickCompleteAlertCancelButton !== undefined) {
            this.findAndPickCompleteAlertCancelButton = source.findAndPickCompleteAlertCancelButton;
        }
        if (source.findAndPickCompleteAlertSubmitButton !== undefined) {
            this.findAndPickCompleteAlertSubmitButton = source.findAndPickCompleteAlertSubmitButton;
        }
        if (source.accessibilityDescriptionCancelButton !== undefined) {
            this.accessibilityDescriptionCancelButton = source.accessibilityDescriptionCancelButton;
        }
        if (source.accessibilityDescriptionFlashButton !== undefined) {
            this.accessibilityDescriptionFlashButton = source.accessibilityDescriptionFlashButton;
        }
        if (source.accessibilityDescriptionZoomButton !== undefined) {
            this.accessibilityDescriptionZoomButton = source.accessibilityDescriptionZoomButton;
        }
        if (source.accessibilityDescriptionFlipCameraButton !== undefined) {
            this.accessibilityDescriptionFlipCameraButton = source.accessibilityDescriptionFlipCameraButton;
        }
        if (source.cameraPermissionEnableCameraTitle !== undefined) {
            this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
        }
        if (source.cameraPermissionEnableCameraExplanation !== undefined) {
            this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
        }
        if (source.cameraPermissionEnableCameraButton !== undefined) {
            this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
        }
        if (source.cameraPermissionCloseButton !== undefined) {
            this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
        }
        if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionEnableCameraButton =
                source.accessibilityDescriptionCameraPermissionEnableCameraButton;
        }
        if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionCloseButton =
                source.accessibilityDescriptionCameraPermissionCloseButton;
        }
    }
}
//# sourceMappingURL=BarcodeTextLocalization.js.map